/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import ReactPlayerLoader from "@brightcove/react-player-loader";
import { BC_ACCOUNT_ID, BC_PLAYER_ID } from "@helper/getEnvVariables";
import type { VideoPlayerRef } from "@typings/Brightcove.d";
import cx from "classnames";
import { ReactElement } from "react";

import styles from "./BrightcoveVideo.module.css";
import useBrightcoveVideo from "./hooks/useBrightcoveVideo";

type BrightcoveVideoProps = {
  videoId: string;
  forwardedRef?: React.Ref<HTMLDivElement>;
  smallWidget?: boolean;
  onEnded?: () => void;
  nextPlaylist?: () => void;
  className?: string;
  playerId?: string;
  onPlayerReady?: (player: VideoPlayerRef) => void;
  playlistId?: string;
};

export function BrightcoveVideo({
  videoId,
  forwardedRef,
  onEnded,
  nextPlaylist,
  className,
  playerId,
  onPlayerReady,
  playlistId,
}: BrightcoveVideoProps): ReactElement {
  /**
   * @param {Object} success - The success object containing reference to the player.
   * @param {ReactPlayer} success.ref - Reference to the player.
   */

  playerId = playerId ? playerId : BC_PLAYER_ID;

  const { videoRef, handleSuccess } = useBrightcoveVideo({
    onEnded,
    nextPlaylist,
    onPlayerReady,
  });

  return (
    <div
      key={videoId}
      data-testid={videoId}
      className={cx(styles.brightcove, className)}
      ref={forwardedRef}
    >
      <ReactPlayerLoader
        style={{ gridColumn: 1, gridRow: 1 }}
        accountId={BC_ACCOUNT_ID}
        playerId={playerId}
        {...(playlistId ? { playlistId } : { videoId })}
        videoRef={videoRef}
        onSuccess={handleSuccess}
      />
    </div>
  );
}
